export const SAMPLE_RESUME = {
  name: "Alex Morgan",
  title: "Senior Product Manager",
  email: "alex.morgan@email.com",
  phone: "(555) 214-8890",
  location: "Austin, TX",
  website: "linkedin.com/in/alexmorgan",
  summary:
    "Product leader with 7 years shipping B2B SaaS. Turns messy customer problems into focused roadmaps, aligns engineering and design around measurable outcomes, and has grown recurring revenue through pricing and onboarding work.",
  experience: [
    {
      id: "a", role: "Senior Product Manager", company: "Brightline Software", location: "Austin, TX", start: "2021", end: "Present",
      bullets: "Led a 9-person billing squad, launching usage-based pricing that lifted expansion revenue 18%\nRedesigned self-serve onboarding, cutting time-to-value from 6 days to 2\nBuilt a weekly customer interview program that shaped 3 roadmap bets",
    },
    {
      id: "b", role: "Product Manager", company: "Northwind Labs", location: "Remote", start: "2018", end: "2021",
      bullets: "Owned the mobile app backlog for 400k monthly users\nShipped an analytics dashboard adopted by 60% of accounts within a quarter",
    },
  ],
  education: [{ id: "c", degree: "B.S. Business Information Systems", school: "University of Texas at Austin", start: "2012", end: "2016", details: "" }],
  skills: "Product strategy, Roadmapping, User research, Pricing, SQL, A/B testing, Agile, Stakeholder management",
};

export const TEMPLATES = [
  { id: "classic", name: "Classic", note: "Serif, centred, timeless" },
  { id: "modern", name: "Modern", note: "Two columns, thread accent" },
  { id: "minimal", name: "Minimal", note: "Hairlines and mono details" },
  { id: "bold", name: "Bold", note: "Cobalt header, strong and confident" },
  { id: "vivid", name: "Vivid", note: "Colourful headings and skill tags" },
];
